export default __webpack_public_path__ + "static/blog-05-1170x600-08e2b1476ba0ed5c4e6d9444243f1f49.jpg";